import { useWheel } from '../context/WheelContext';

function ModeToggle() {
  const { isSharkMode, toggleSharkMode } = useWheel();

  return (
    <div className="flex items-center gap-3">
      <button
        onClick={toggleSharkMode}
        className={`
          relative inline-flex h-6 w-11 items-center rounded-full
          transition-colors duration-300
          ${isSharkMode ? 'bg-blue-600' : 'bg-secondary-200'}
        `}
      >
        <span
          className={`
            inline-block h-4 w-4 transform rounded-full bg-white shadow-lg
            transition-transform duration-300
            ${isSharkMode ? 'translate-x-6' : 'translate-x-1'}
          `}
        />
        <span className="sr-only">Modo Tiburón</span>
      </button>
      <span className="text-sm font-medium text-secondary-700">
        {isSharkMode ? '🦈 Modo Tiburón' : '🎲 Modo Normal'}
      </span>
    </div>
  );
}

export default ModeToggle; 